import { faEye } from '@fortawesome/free-regular-svg-icons';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import $ from "jquery";
import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Form, Row, Table } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { useNavigate } from 'react-router-dom';
import AsyncSelect from 'react-select/async';
import * as Common from "../../Common";
import Dialog from '../../Dialog';
import LoginHeader from '../../Login_header';
import Menu from '../../Menu';
import * as Picklist from '../../Picklist';

const Balance_sheet = () => {
    const startDate = sessionStorage.getItem('startDate');
    const endDate = sessionStorage.getItem('endDate');
    const branchDisable = sessionStorage.getItem('branchDisable');
    const HOCODE = sessionStorage.getItem('hocode');
    const navigate = useNavigate();
    const sid = sessionStorage.getItem('sessionId');
    const [userRight, setUserRight] = useState([]);
    //----------------------------------------------------------------------------------------------REPORT HEADER USES  
    const [headerProduct, setHeaderProduct] = useState("");
    const [headerIsd, setHeaderIsd] = useState("");
    const [headerBranch, setHeaderBranch] = useState("");
    const [headerValuation, setHeaderValuation] = useState("");
    const [headerGroup, setHeaderGroup] = useState("");
    const [headerAccount, setHeaderAccount] = useState("");
    //--------------------------------------------------------------------------------------------------MSG BOX 
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");
    //--------------------------------------------------------------------------------------------------MAIN SCREEN FILTERS
    const [fromDate, setFromDate] = useState(new Date());
    const [toDate, setToDate] = useState(new Date());
    const [counter, setCounter] = useState(0);
    const [filterBalanceBookType, setFilterBalanceBookType] = useState("O");
    const [filterLocationType, setFilterLocationType] = useState("O");
    const [filterLocation, setFilterLocation] = useState(null);
    const [locationCode, setLocationCode] = useState(0);
    const [hdrSrno, setHdrSrno] = useState("");
    //--------------------------------------------------------------------------------------------------SCREEN MODE 
    const [scrMode, setScrMode] = useState("");

    //--------------------------------------------------------------------------------------------------TABLES
    const [activityLogData, setActivityLogData] = useState([]);

    const [cnEvtmGroupWiseData, setCnEvtmGroupWiseData] = useState([]);
    const [cnEvtmIsdWiseData, setCnEvtmIsdWiseData] = useState([]);
    const [cnEvtmIsdToBranchWiseData, setCnEvtmIsdToBranchWiseData] = useState([]);
    const [cnEvtmIsdCalculationData, setCnEvtmIsdCalculationData] = useState([]);

    const [cnEvtmBranchWiseData, setCnEvtmBranchWiseData] = useState([]);
    const [cnEvtmBranchToIsdWiseData, setCnEvtmBranchToIsdWiseData] = useState([])
    const [trialBalanceData, setTrialBalanceData] = useState([]);
    const [trialAccountWiseData, setTrialAccountWiseData] = useState([]);
    const [trialAccountToBranchWiseData, setTrialAccountToBranchWiseData] = useState([]);
    const [trialBranchWiseData, setTrialBranchWiseData] = useState([]);
    const [trialBrancToAccounthWiseData, setTrialBrancToAccounthWiseData] = useState([]);
    const [tradingBalanceData, setTradingBalanceData] = useState([]);
    const [tradingToBranchWiseData, setTradingToBranchWiseData] = useState([]);
    const [scheduleParentGroupWiseData, setScheduleParentGroupWiseData] = useState([]);
    const [scheduleChildGroupWiseData, setScheduleChildGroupWiseData] = useState([]);
    const [scheduleChildGroupToBranchWiseData, setScheduleChildGroupToBranchWiseData] = useState([])
    const [profitLossGroupWiseData, setProfitLossGroupWiseData] = useState([]);
    const [plGrpToAccountWiseData, setPlGrpToAccountWiseData] = useState([]);
    const [pLGroupAccountToBranchWiseData, setPLGroupAccountToBranchWiseData] = useState([]);


    const [onceRun, setOnceRun] = useState(false);

    var msg = [], i = 0;

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.getActiveBranch().then(response => {
                setFilterLocation(response);
                response != null && handleChangeLocation(response);
            });
            Common.callApi(Common.apiRight, [sid, 'all', 'REP_BALANCE_SHEET'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                } else {
                    navigate('/');
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);

    const handleLocationType = (e) => {
        setFilterLocationType(e.target.value);
        if (e.target.value === 'A') {
            setLocationCode(0);
        } else {
            Common.getActiveBranch().then(response => {
                setFilterLocation(response);
                response != null && handleChangeLocation(response);
            });
        }
    }
    const handleChangeLocation = (value) => {
        setFilterLocation(value);
        const loc = value.id.split('^');
        setLocationCode(loc[1]);
        sessionStorage.activeBranch = loc[1];
    }
    const generateObjectCNEVTM = (filtercn, filtervtm, filterevtm, filterdd, filtertt, balancebooktype) => {
        var obj = {
            repname: 'BSHEET',
            srno: hdrSrno,
            filterLocationType: filterLocationType,
            radioTypeLocation: filterLocationType,
            location: locationCode,
            fromDate: Common.dateYMD(fromDate),
            toDate: Common.dateYMD(toDate),
            tillDate: Common.dateYMD(toDate),
            filterBalanceBookType: balancebooktype,
            repLevelGlobal: filterLocationType == "A" ? true : false,
            repLevelLocal: true,
            showHeader: false,
            filterCN: filtercn,
            filterVTM: filtervtm,
            filterEVTM: filterevtm,
            filterDD: filterdd,
            filterTT: filtertt,
        }
        return obj;
    }
    //------------------------------------------------------------------------------------------------------------------BALANCE BOOK GENERATION
    const handleGenerate = () => {
        // setScreenReportGeneration(true);
        $(".loader").show();
        if (filterBalanceBookType === 'T') {
            if (!Common.validateFinYear(Common.dateYMD(toDate))) {
                $(".loader").hide();
                setMsgText("Date should be within financial year");
                setMsgBox(true);
                return;
            }
        } else if (filterBalanceBookType === 'P') {
            if (!Common.validateFinYear(Common.dateYMD(fromDate), Common.dateYMD(toDate))) {
                $(".loader").hide();
                setMsgBox(true);
                setMsgText("Date should be within financial year");
                return;
            } else if (fromDate > toDate) {
                $(".loader").hide();
                setMsgText("From Date should be less than To Date");
                setMsgBox(true);
                return;
            }
        }

        setScrMode('REPORT_GENERATION')
        if (fromDate == null || toDate == null) {
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (fromDate == null ? "Please select from date." : '');
            msg[i++] = (toDate == null ? "Please select to date." : '');
            $(".loader").hide();
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            handleRightsCheck();
        }
    }
    const handleRightsCheck = () => {
        var msg = [], i = 0;
        Promise.all([
            Common.callApiPromise(Common.apiRight, [sid, 'all', 'REP_VALUATION_GLOBAL']),
            Common.callApiPromise(Common.apiRight, [sid, 'all', 'REP_VALUATION_LOCAL']),
            Common.callApiPromise(Common.apiRight, [sid, 'all', 'TRIAL_BALANCE']),
        ])
            .then(([valuationGlobal, valuationLocal, trialBalance]) => {
                if (valuationGlobal.query === '0') {
                    msg[i++] = ("Rights Not Allowed for Rep Global Valuation");
                }
                if (valuationLocal.query === '0') {
                    msg[i++] = ("Rights Not Allowed for Rep Local Valuation");
                }
                if (trialBalance.query === '0') {
                    msg[i++] = ("Rights Not Allowed for Rep Trial Balance");
                }
                if (i > 0) {
                    setScrMode("");
                    $(".loader").hide();
                    setMsgText(Common.buildMessageFromArray(msg));
                    setMsgBox(true);
                } else {
                    handleGenerateRequest(i, msg);
                }
            })
            .catch(error => alert(error));
    }
    function handleGenerateRequest(i, msg) {
        msg[i++] = ("Balance Sheet Generating...");
        setMsgText(Common.buildMessageFromArray(msg));
        setMsgBox(true);
        var balancebooktype = filterBalanceBookType;
        var fromdatedmy = Common.dateYMD(fromDate);
        if (filterBalanceBookType == 'P' && startDate === fromdatedmy) {
            balancebooktype = 'T'
            setFilterBalanceBookType('T');
        }
        const obj = {
            location: locationCode,
            fromDate: balancebooktype === 'O' ? new Date(new Date(startDate).setDate(new Date(startDate).getDate() - 1)).toISOString().split("T")[0] : (balancebooktype === 'P' && startDate != fromDate) ? Common.dateYMD(fromDate) : startDate,
            toDate: balancebooktype === 'O' ? new Date(new Date(startDate).setDate(new Date(startDate).getDate() - 1)).toISOString().split("T")[0] : Common.dateYMD(toDate),
            tillDate: Common.dateYMD(toDate),
            filterBalanceBookType: balancebooktype,
            filterLocationType: filterLocationType,
            location: locationCode,
            showHeader: false,
        }
        Common.callApi(Common.apibalancesheet, [sid, "insertactivitylog", JSON.stringify(obj)], result => {
            let resp = JSON.parse(result);
            setHdrSrno(resp.srno);
            if ((balancebooktype === 'P') || balancebooktype === 'T') {
                insertCNEVTM(resp, i, msg, balancebooktype);
            } else {
                insertTrail(resp, i, msg, balancebooktype);
            }
        })
    }
    //                                                                                              CN/VTM/EVTM BALANCE BOOK GENERATION ----STOCK VALUATION
    const insertCNEVTM = (resp, i, msg, balancebooktype) => {
        const objCN = generateObjectCNEVTM(true, false, false, false, false, balancebooktype);
        const objVTM = generateObjectCNEVTM(false, true, false, false, false, balancebooktype);
        const objEVTM = generateObjectCNEVTM(false, false, true, false, false, balancebooktype);
        const objDD = generateObjectCNEVTM(false, false, false, true, false, balancebooktype);
        const objTT = generateObjectCNEVTM(false, false, false, false, true, balancebooktype);
        Promise.all([
            Common.callApiPromise(Common.apibalancesheet, [sid, 'currencyinsertion', JSON.stringify(objCN), resp.srno]),
            Common.callApiPromise(Common.apibalancesheet, [sid, 'vtminsertion', JSON.stringify(objVTM), resp.srno]),
            Common.callApiPromise(Common.apibalancesheet, [sid, 'evtminsertion', JSON.stringify(objEVTM), resp.srno]),
            Common.callApiPromise(Common.apibalancesheet, [sid, 'ddinsertion', JSON.stringify(objDD), resp.srno]),
            Common.callApiPromise(Common.apibalancesheet, [sid, 'ttinsertion', JSON.stringify(objTT), resp.srno]),
        ])
            .then(([iscurrencyinserted, isvtminserted, isevtminserted, isddinserted, isttinserted]) => {
                if (iscurrencyinserted.msg === "MSG0000" && isvtminserted.msg === "MSG0000" && isevtminserted.msg === "MSG0000" && isddinserted.msg === "MSG0000" && isttinserted.msg === "MSG0000") {
                    msg[i++] = ("CN/EVTM/VTM/DD/TT Balance Sheet Generated .");
                    setMsgText(Common.buildMessageFromArray(msg));
                    setMsgBox(true);
                    insertTrail(resp, i, msg, balancebooktype);
                } else {
                    setMsgText("CN/EVTM/VTM/DD/TT  Balance Sheet Generation Failed");
                    setMsgBox(true);
                    $(".loader").hide();
                }
            })
            .catch(error => alert(error));
    }
    //                                                                                              TRIAL BALANCE BOOK GENERATION
    const insertTrail = (resp, i, msg, balancebooktype) => {
        const obj = {
            srno: resp.srno,
            filterLocationType: filterLocationType,
            radioTypeLocation: filterLocationType,
            locationType: filterLocationType,
            location: locationCode,
            fromDate: balancebooktype === 'O' ? new Date(new Date(startDate).setDate(new Date(startDate).getDate() - 1)).toISOString().split("T")[0] : balancebooktype === 'P' ? Common.dateYMD(fromDate) : startDate,
            toDate: balancebooktype === 'O' ? new Date(new Date(startDate).setDate(new Date(startDate).getDate() - 1)).toISOString().split("T")[0] : Common.dateYMD(toDate),
            filterBalanceBookType: balancebooktype,
            repLevelGlobal: (filterLocationType == "A") || (filterLocationType === 'O' && filterLocation === HOCODE) ? true : false,
            repLevelLocal: true,
            showHeader: false,
            checkItem: true
        }
        Common.callApi(Common.apibalancesheet, [sid, "trailbalancebook", JSON.stringify(obj), resp.srno], result => {
            let resp = JSON.parse(result);
            if (resp.msg === "MSG0000") {
                msg[i++] = ("Trail Balance Sheet Generated");
                if (balancebooktype === "O") {
                    msg[i++] = ("Schedule Balance Sheet Generated");
                } else {
                    msg[i++] = ("Trading Sheet Generated");
                    msg[i++] = ("Profit and Loss Balance Sheet Generated");
                    msg[i++] = ("Schedule Balance Sheet Generated");
                }
                msg[0] = ("Balance Sheet Generated");
                setMsgText(Common.buildMessageFromArray(msg));
                setMsgBox(true);
                $(".loader").hide();
            } else {
                setMsgText("Trail Balance Sheet Generation Failed . ");
                setMsgBox(true);
                $(".loader").hide();
            }

        })

    }
    //------------------------------------------------------------------------------------------------------------------BACK BUTTONS 
    const handleBackScreenReportGeneration = (previousscreenmode) => {
        setScrMode(previousscreenmode);
    }
    //------------------------------------------------------------------------------------------------------------------REPORT LOG 
    const handleReportLog = () => {
        var balancebooktype = filterBalanceBookType;
        var fromdatedmy = Common.dateYMD(fromDate);
        if (filterBalanceBookType == 'P' && startDate === fromdatedmy) {
            balancebooktype = 'T'
        }
        const obj = {
            fromDate: balancebooktype === 'O' ? new Date(new Date(startDate).setDate(new Date(startDate).getDate() - 1)).toISOString().split("T")[0] : balancebooktype === 'P' ? Common.dateYMD(fromDate) : startDate,
            toDate: balancebooktype === 'O' ? new Date(new Date(startDate).setDate(new Date(startDate).getDate() - 1)).toISOString().split("T")[0] : Common.dateYMD(toDate),
            filterLocationType: filterLocationType,
            location: locationCode,
            filterBalanceBookType: balancebooktype,
        }
        Common.callApi(Common.apibalancesheet, [sid, "activitylogview", JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            setActivityLogData(resp.activitylogdata);
            setScrMode('ACTIVITY_LOG');
        })
    }
    const handleActivityLogDetail = (srno) => {
        setHdrSrno(srno);
        setScrMode('REPORT_GENERATION');
    }
    //------------------------------------------------------------------------------------------------------------------STOCK VALUATION 
    const handleCNVTMEVTMView = () => {
        $(".loader").show();
        Common.callApi(Common.apibalancesheet, [sid, "cnevtmviewgroupby", hdrSrno], (result) => {
            let resp = JSON.parse(result);
            setCnEvtmGroupWiseData(resp.cnEvtmGroupByData);
            $(".loader").hide();
            setScrMode("CNEVTM_VIEW")
        })
    }
    const handleCnEvtmIsdWiseView = (srno, product, valuation) => {
        setHeaderProduct(product);
        setHeaderValuation(valuation);
        $(".loader").show();
        const obj = {
            srno: srno,
            product: product,
        }
        Common.callApi(Common.apibalancesheet, [sid, "cnEvtmIsdWiseView", JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            setCnEvtmIsdWiseData(resp.cnevtmisdwisedata);
            setScrMode("CNEVTM_ISD_WISE")
            $(".loader").hide();
        })
    }
    const handleCnEvtmIsdWiseDownload = (srno, product, valuation) => {
        setHeaderProduct(product);
        setHeaderValuation(valuation);
        $(".loader").show();
        const obj = {
            srno: srno,
            product: product,
        }
        Common.callDownloadApiPost1(Common.apibalancesheet, "post", [sid, "downloadCnEvtmIsdWise", JSON.stringify(obj)], result => {
            $(".loader").hide();
            setMsgText(Common.buildMessageFromArray([result]));
            setMsgBox(true);
        });
    }
    const handleCnEvtmIsdToBranchWiseView = (srno, product, branch, isd, valuation) => {
        setHeaderValuation(valuation)
        setHeaderIsd(isd);
        $(".loader").show();
        const obj = {
            srno: srno,
            product: product,
            branchCode: branch,
            isd: isd
        }
        Common.callApi(Common.apibalancesheet, [sid, "cnEvtmIsdToBranchWiseView", JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            setCnEvtmIsdToBranchWiseData(resp.cnevtmisdtobranchwisedata);
            setScrMode("CNEVTM_ISD_TO_BRANCH_WISE")
            $(".loader").hide();
        })
    }
    const handleCnEvtmIsdCalculations = (srno, product, branch, isd, valuation, dumpsrno) => {
        setHeaderValuation(valuation)
        setHeaderIsd(isd);
        $(".loader").show();
        const obj = {
            srno: srno,
            product: product,
            branchCode: branch,
            isd: isd,
            dumpsrno: dumpsrno
        }
        Common.callApi(Common.apibalancesheet, [sid, "cnEvtmIsdCalculationView", JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            setCnEvtmIsdCalculationData(resp.cnevtmisdcalculationdata);
            setScrMode("CNEVTM_ISD_CALCULATION")
            $(".loader").hide();
        })
    }
    const handleCnEvtmBranchWiseView = (srno, product, valuation) => {
        setHeaderProduct(product);
        setHeaderValuation(valuation);
        $(".loader").show();
        const obj = {
            srno: srno,
            product: product,
        }
        Common.callApi(Common.apibalancesheet, [sid, "cnEvtmBranchWiseView", JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            setCnEvtmBranchWiseData(resp.cnevtmbranchwisedata);
            setScrMode("CNEVTM_BRANCH_WISE");
            $(".loader").hide();
        })
    }
    const handleCnEvtmBranchToIsdWiseView = (srno, product, branch, branchname) => {
        setHeaderBranch(branchname);
        $(".loader").show();
        const obj = {
            srno: srno,
            product: product,
            branchCode: branch
        }
        Common.callApi(Common.apibalancesheet, [sid, "cnEvtmBranchToIsdWiseView", JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            setCnEvtmBranchToIsdWiseData(resp.cnevtmbranchtoisdwisedata);
            setScrMode("CNEVTM_BRANCH_TO_ISD_WISE")
            $(".loader").hide();
        })
    }
    //------------------------------------------------------------------------------------------------------------------CONSOLIDATE TRIAL 
    const handleTrialBalanceView = () => {
        $(".loader").show();
        Common.callApi(Common.apibalancesheet, [sid, "trialbalanceview", hdrSrno], (result) => {
            let resp = JSON.parse(result);
            setTrialBalanceData(resp.trialbalancedata);
            $(".loader").hide();
            setScrMode("TRIAL_BALANCE_VIEW")
        })
    }
    const handleTrialAccountWiseView = (item) => {
        setHeaderGroup(item.trt_group);
        $(".loader").show();
        const obj = {
            srno: item.trt_srno,
            group: item.trt_group,
        }
        Common.callApi(Common.apibalancesheet, [sid, "trialAccountWiseView", JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            setTrialAccountWiseData(resp.trialaccountwisedata);
            setScrMode("TRIAL_ACCOUNT_WISE")
            $(".loader").hide();
        })
    }
    const handleTrialAccountToBranchWiseView = (item) => {
        setHeaderGroup(item.trt_group);
        setHeaderAccount(item.trt_account);
        $(".loader").show();
        const obj = {
            srno: item.trt_srno,
            group: item.trt_group,
            account: item.trt_account
        }
        Common.callApi(Common.apibalancesheet, [sid, "trialAccounttobranchWiseView", JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            setTrialAccountToBranchWiseData(resp.trialaccounttobranchwisedata);
            setScrMode("TRIAL_ACCOUNT_TO_BRANCH_WISE")
            $(".loader").hide();
        })
    }
    const handleTrialBranchWiseView = (item) => {
        setHeaderGroup(item.trt_group);
        $(".loader").show();
        const obj = {
            srno: item.trt_srno,
            group: item.trt_group,
        }
        Common.callApi(Common.apibalancesheet, [sid, "trialBranchWiseView", JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            setTrialBranchWiseData(resp.trialbranchwisedata);
            setScrMode("TRIAL_BRANCH_WISE")
            $(".loader").hide();
        })
    }
    const handleTrialBranchToAccountWiseView = (item) => {
        setHeaderAccount(item.trt_account);
        setHeaderGroup(item.trt_group);
        $(".loader").show();
        const obj = {
            srno: item.trt_srno,
            group: item.trt_group,
            branch: item.trt_branch_code,
        }
        Common.callApi(Common.apibalancesheet, [sid, "trialBranchToAccountWiseView", JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            setTrialBrancToAccounthWiseData(resp.trialbranchtoaccountwisedata);
            setScrMode("TRIAL_BRANCH_TO_ACCOUNT_WISE")
            $(".loader").hide();
        })
    }
    //------------------------------------------------------------------------------------------------------------------TRADING 
    const handleTradingView = () => {
        $(".loader").show();
        Common.callApi(Common.apibalancesheet, [sid, "tradingbalanceview", hdrSrno], (result) => {
            let resp = JSON.parse(result);
            setTradingBalanceData(resp.tradingbalanceview);
            $(".loader").hide();
            setScrMode("TRADING_BALANCE_VIEW")
        })

    }
    const handleTradingToBranchWiseView = (item) => {
        setHeaderAccount(item.trt_account);
        setHeaderGroup(item.trt_group);
        $(".loader").show();
        const obj = {
            srno: item.trt_srno,
            group: item.trt_group,
            account: item.trt_account
        }
        Common.callApi(Common.apibalancesheet, [sid, "tradingToBranchWiseView", JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            setTradingToBranchWiseData(resp.tradingtobranchwisedata);
            setScrMode("TRADING_BRANCH_WISE")
            $(".loader").hide();
        })
    }
    //------------------------------------------------------------------------------------------------------------------PROFIT AND LOSS 
    const handleProfitLossGroupWiseView = () => {
        $(".loader").show();
        Common.callApi(Common.apibalancesheet, [sid, "profitlossGroupWiseView", hdrSrno], (result) => {
            let resp = JSON.parse(result);
            setProfitLossGroupWiseData(resp.profitlossgroupwisedata);
            $(".loader").hide();
            setScrMode("PROFITLOSS_GROUP_WISE")
        })
    }
    const handleProfitLossGroupToAccountWiseView = (item) => {
        setHeaderGroup(item.trt_group);
        $(".loader").show();
        const obj = {
            srno: item.trt_srno,
            group: item.trt_group,
        }
        Common.callApi(Common.apibalancesheet, [sid, "profitlossgrouptoaccountwise", JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            setPlGrpToAccountWiseData(resp.profitlossgrouptoaccountwisedata);
            setScrMode("PROFITLOSS_GROUP_TO_ACCOUNT_WISE")
            $(".loader").hide();
        })
    }
    const handlePLGroupAccountToBranchWiseView = (item) => {
        setHeaderGroup(item.trt_group);
        setHeaderAccount(item.trt_account);
        $(".loader").show();
        const obj = {
            srno: item.trt_srno,
            group: item.trt_group,
            account: item.trt_account,
        }
        Common.callApi(Common.apibalancesheet, [sid, "plgrpaccttobranchwise", JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            setPLGroupAccountToBranchWiseData(resp.plgrpaccttobranchwisedata);
            setScrMode("PROFITLOSS_GROUPACCOUNT_TO_BRANCH_WISE")
            $(".loader").hide();
        })
    }
    //------------------------------------------------------------------------------------------------------------------SCHEDULE 
    const handleScheduleGroupWiseView = () => {
        $(".loader").show();
        Common.callApi(Common.apibalancesheet, [sid, "scheduleParentGroupWiseView", hdrSrno], (result) => {
            let resp = JSON.parse(result);
            setScheduleParentGroupWiseData(resp.scheduleparentgroupwisedata);
            $(".loader").hide();
            setScrMode("SCHEDULE_PARENT_GROUP_WISE")
        })
    }
    const handleScheduleChildGroupWiseView = (item) => {
        $(".loader").show();
        const obj = {
            srno: item.trt_srno,
            parentGroup: item.mbs_srno,
        }
        Common.callApi(Common.apibalancesheet, [sid, "scheduleChildGroupWiseView", JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            setScheduleChildGroupWiseData(resp.schedulechildgroupwisedata);
            setScrMode("SCHEDULE_CHILD_GROUP_WISE")
            $(".loader").hide();
        })
    }
    const handleScheduleChildGroupToBranchWiseView = (item) => {
        setHeaderGroup(item.trt_group);
        $(".loader").show();
        const obj = {
            srno: item.trt_srno,
            parentGroup: item.mbs_srno,
            childGroup: item.trt_group,
        }
        Common.callApi(Common.apibalancesheet, [sid, "scheduleChildGroupToBranchWiseView", JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            setScheduleChildGroupToBranchWiseData(resp.schedulechildgrouptobranchwisedata);
            setScrMode("SCHEDULE_CHILD_GROUP_TO_BRANCH_WISE")
            $(".loader").hide();
        })
    }
    const handleViewDownload = (balancesheettype, generatetype) => {
        $(".loader").show();
        const obj = {
            srno: hdrSrno,
            balancesheettype: balancesheettype,
        }
        if (generatetype === 'D') {
            Common.callDownloadApiPost1(Common.apibalancesheet, "post", [sid, "download", JSON.stringify(obj)], result => {
                $(".loader").hide();
                setMsgText(Common.buildMessageFromArray([result]));
                setMsgBox(true);
            });
        } else {
            Common.callApi(Common.apibalancesheet, [sid, "view", JSON.stringify(obj)], result => {
                var newWindow = window.open();
                newWindow.document.write(result);
                $(".loader").hide();
            });

        }

    }
    return (
        <div>
            <LoginHeader />
            <Menu />

            <Container fluid>
                <>
                    {scrMode === "" ?
                        <>
                            <Row>
                                <Col>
                                    <h2>Balance Sheet<span style={{ color: "#f8f9fd" }}>{counter}</span> </h2>
                                </Col>
                            </Row>&nbsp;
                            <Row>
                                <Col className='col-md-3 col-6'>
                                    <Form.Group>
                                        <Form.Label>Location Type <span className="text-danger">*</span></Form.Label>
                                        <Form.Select value={filterLocationType} onChange={handleLocationType}
                                            disabled={branchDisable === "true"}
                                            required>
                                            <option value="O">One</option>
                                            <option value="A">All</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                {filterLocationType === 'O' ? <>
                                    <Col className='col-md-3 col-6'>
                                        <Form.Group>
                                            <Form.Label>Location<span className="text-danger">*</span></Form.Label>
                                            <AsyncSelect
                                                cacheOptions={false}
                                                defaultOptions={false}
                                                value={filterLocation}
                                                getOptionLabel={e => e.label + ' '}
                                                getOptionValue={e => e.id}
                                                loadOptions={Picklist.fetchLocationAllowedPicklist}
                                                onInputChange={Picklist.handleInputChange}
                                                onChange={handleChangeLocation}
                                                isDisabled={branchDisable === "true"}
                                            >
                                            </AsyncSelect>
                                        </Form.Group>
                                    </Col></> : null}
                            </Row>
                            <Row>&nbsp;</Row>
                            <Row>
                                <Col className='col-md-3 col-6'>
                                    <Form.Group>
                                        <Form.Label>Mode<span className="text-danger">*</span></Form.Label>
                                        <Form.Select value={filterBalanceBookType} onChange={e => setFilterBalanceBookType(e.target.value)}
                                            required>
                                            <option value="O">Opening</option>
                                            <option value="P">Periodic</option>
                                            <option value="T">Till Date</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                {(filterBalanceBookType === 'P') ?
                                    <>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>From Date<span className="colorThemeRed">*</span></Form.Label><br />
                                                <DatePicker className="form-control"
                                                    selected={fromDate}
                                                    onChange={(date) => setFromDate(date)}
                                                    dateFormat="dd/MM/yyyy"
                                                    showYearDropdown
                                                    showMonthDropdown
                                                    useShortMonthInDropdown
                                                    dropdownMode="select"
                                                    peekNextMonth
                                                    customInput={
                                                        <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                    }
                                                />
                                            </Form.Group>
                                        </Col>
                                    </> : null}
                                {(filterBalanceBookType === 'T') || (filterBalanceBookType === 'P') ?
                                    <Col className='col-md-3 col-6'>
                                        <Form.Group>
                                            <Form.Label>{filterBalanceBookType === 'T' ? 'Till Date' : 'To Date'}<span className="colorThemeRed">*</span></Form.Label><br />
                                            <DatePicker className="form-control"
                                                selected={toDate}
                                                onChange={(date) => setToDate(date)}
                                                dateFormat="dd/MM/yyyy"
                                                showYearDropdown
                                                showMonthDropdown
                                                useShortMonthInDropdown
                                                dropdownMode="select"
                                                peekNextMonth
                                                customInput={
                                                    <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                }
                                            />
                                        </Form.Group>
                                    </Col> : null}

                            </Row>
                            <Row>&nbsp;</Row>
                            <Row>
                                <Col className='col-md-3 col-3'>
                                    <Button variant='outline-success' className='buttonStyle' size='sm' onClick={handleGenerate}>Generate</Button>
                                    &nbsp;
                                    <Button variant='outline-success' className='buttonStyle' size='sm' onClick={handleReportLog}>Reports Log</Button>
                                </Col>
                            </Row>
                        </> : null}
                    {scrMode === 'REPORT_GENERATION' ?
                        <>
                            <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => handleBackScreenReportGeneration("")}>Back</Button>
                            <Row>
                                <h5>Balance Book Generated Successfully</h5>
                                {(filterBalanceBookType === 'P') || (filterBalanceBookType === 'T') ?
                                    <>
                                        <ul className='list-inline'>
                                            <li ><span onClick={() => handleCNVTMEVTMView()} className='colorThemeBlue pointer'><FontAwesomeIcon icon={faEye} /></span>  Stock Valuation</li> &nbsp;
                                            <li><span onClick={() => handleTrialBalanceView()} className='colorThemeBlue pointer'><FontAwesomeIcon icon={faEye} /></span>     Consolidate Trial</li>&nbsp;
                                            <li ><span onClick={() => handleTradingView()} className='colorThemeBlue pointer'><FontAwesomeIcon icon={faEye} /></span>  Trading</li> &nbsp;
                                            <li><span onClick={() => handleProfitLossGroupWiseView()} className='colorThemeBlue pointer'><FontAwesomeIcon icon={faEye} /></span>     Profit & Loss</li>&nbsp;
                                            <li ><span onClick={() => handleScheduleGroupWiseView()} className='colorThemeBlue pointer'><FontAwesomeIcon icon={faEye} /></span>  Schedule</li> &nbsp;
                                        </ul>
                                    </> :
                                    <>
                                        <ul className='list-inline'>
                                            <li><span onClick={() => handleTrialBalanceView()} className='colorThemeBlue pointer'><FontAwesomeIcon icon={faEye} /></span>     Consolidate Trial</li>&nbsp;
                                            <li ><span onClick={() => handleScheduleGroupWiseView()} className='colorThemeBlue pointer'><FontAwesomeIcon icon={faEye} /></span>  Schedule</li> &nbsp;
                                        </ul>
                                    </>}
                            </Row>
                        </> : null}
                    {scrMode === 'ACTIVITY_LOG' ?
                        <>
                            <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => handleBackScreenReportGeneration("")}>Back</Button>
                            <h4>Report Logs</h4>
                            <Row>
                                <Table responsive bordered striped >
                                    <thead>
                                        <tr>
                                            <th>&nbsp;</th>
                                            <th>Date</th>
                                            <th>Time</th>
                                            <th>From Date</th>
                                            <th>To Date</th>
                                            <th>Report Type</th>
                                            <th>&nbsp;</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            activityLogData.map((item, index) => (
                                                <>
                                                    <tr key={index}>
                                                        <td>&nbsp;</td>
                                                        <td>{item.trl_date}</td>
                                                        <td>{item.trl_time}</td>
                                                        <td>{item.trl_from_date}</td>
                                                        <td>{item.trl_to_date}</td>
                                                        <td>{item.trl_report_type === 'O' ? "Opening" : item.trl_report_type === 'P' ? 'Periodic' : 'Till Date'}</td>
                                                        <td>
                                                            {
                                                                <span onClick={() => handleActivityLogDetail(item.trl_srno)} className='colorThemeBlue pointer'>Details</span>
                                                            }
                                                        </td>
                                                    </tr>
                                                </>
                                            ))
                                        }
                                    </tbody>

                                </Table>
                            </Row>
                        </> : null}
                    {scrMode === 'CNEVTM_VIEW' ?
                        <>
                            <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => handleBackScreenReportGeneration("REPORT_GENERATION")}>Back</Button> &nbsp;


                            <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => handleViewDownload("STOCK", 'V')}>Print</Button> &nbsp;
                            <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => handleViewDownload("STOCK", 'D')}>Download</Button>
                            <Row>
                                <h5>Stock Valuation</h5>
                                <Row>
                                    <Table responsive bordered striped >
                                        <thead>
                                            <tr>
                                                <th>Product</th>
                                                <th>Actual </th>
                                                {/* <th>User</th> */}
                                                {/* <th>Profit & Loss</th> */}
                                                <th>&nbsp;</th>
                                                <th>&nbsp;</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                cnEvtmGroupWiseData.map((item, index) => (
                                                    <>
                                                        <tr key={index}>
                                                            <td>{item.trsv_product}</td>
                                                            <td>{item.trsv_valuation}</td>
                                                            {/* <td>{item.trsv_profit_loss}</td> */}
                                                            <td>{<>
                                                                <span onClick={() => handleCnEvtmIsdWiseView(item.trsv_srno, item.trsv_product, item.trsv_valuation)} className='colorThemeBlue pointer'>ISD</span> &nbsp;&nbsp;
                                                                {/* <span onClick={() => handleCnEvtmIsdWiseDownload(item.trsv_srno, item.trsv_product, item.trsv_valuation)} className='colorThemeBlue pointer'> <FontAwesomeIcon icon={faDownload} /></span> */}
                                                            </>
                                                            }</td>
                                                            <td>{
                                                                <span onClick={() => handleCnEvtmBranchWiseView(item.trsv_srno, item.trsv_product, item.trsv_valuation)} className='colorThemeBlue pointer'>Branch</span>
                                                            }</td>
                                                        </tr>
                                                    </>
                                                ))
                                            }
                                        </tbody>

                                    </Table>
                                </Row>
                            </Row>
                        </> : null}
                    {scrMode === 'CNEVTM_ISD_WISE' ?
                        <>
                            <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => handleBackScreenReportGeneration("CNEVTM_VIEW")}>Back</Button>
                            <Row>
                                <h5>Stock Valuation ISD Wise</h5>
                                <Row>
                                    <Col className='col-md-3 col-6'>
                                        <Form.Label>Product : {headerProduct}</Form.Label>
                                    </Col>
                                    <Col className="col-md-2 col-4">
                                        <span>Valuation : <b>{headerValuation} </b></span>
                                    </Col>
                                </Row>
                                <Row>
                                    <Table responsive bordered striped >
                                        <thead>
                                            <tr>
                                                <th>ISD</th>
                                                <th>Quantity </th>
                                                <th>Rate</th>
                                                <th>Valuation</th>
                                                {/* <th>Profit & Loss</th> */}
                                                <th>&nbsp;</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                cnEvtmIsdWiseData.map((item, index) => (
                                                    <>
                                                        <tr key={index}>
                                                            <td>{item.trsv_isd}</td>
                                                            <td>{item.trsv_remaining_qty}</td>
                                                            <td>{item.trsv_rate}</td>
                                                            <td>{item.trsv_valuation}</td>
                                                            {/* <td>{item.trsv_profit_loss}</td> */}
                                                            <td>{
                                                                <span onClick={() => handleCnEvtmIsdToBranchWiseView(item.trsv_srno, item.trsv_product, item.trsv_branch_code, item.trsv_isd, item.trsv_valuation)} className='colorThemeBlue pointer'>Branch</span>
                                                            }</td>
                                                            {branchDisable === "true" ?
                                                                <td>{
                                                                    <span onClick={() => handleCnEvtmIsdCalculations(item.trsv_srno, item.trsv_product, item.trsv_branch_code, item.trsv_isd, item.trsv_valuation, item.trsv_dump_srno)} className='colorThemeBlue pointer'>Calculations</span>
                                                                }</td>
                                                                : null}
                                                        </tr>
                                                    </>
                                                ))
                                            }
                                        </tbody>

                                    </Table>
                                </Row>
                            </Row>
                        </> : null}
                    {scrMode === 'CNEVTM_ISD_TO_BRANCH_WISE' ?
                        <>
                            <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => handleBackScreenReportGeneration("CNEVTM_ISD_WISE")}>Back</Button>
                            <Row>
                                <h5>Stock Valuation ISD To Branch Wise </h5>
                                <Row>
                                    <Col className='col-md-3 col-6'>
                                        <Form.Label>Product : {headerProduct}</Form.Label>
                                    </Col>
                                    <Col className="col-md-2 col-4">
                                        <span>Valuation : <b>{headerValuation} </b></span>
                                    </Col>
                                    <Col className="col-md-2 col-4">
                                        <span>ISD : <b>{headerIsd} </b></span>
                                    </Col>
                                </Row>
                                <Row>
                                    <Table responsive bordered striped >
                                        <thead>
                                            <tr>
                                                <th>Branch</th>
                                                <th>Quantity </th>
                                                <th>Rate</th>
                                                <th>Valuation</th>
                                                {/* <th>Profit & Loss</th> */}
                                                <th>&nbsp;</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                cnEvtmIsdToBranchWiseData.map((item, index) => (
                                                    <>
                                                        <tr key={index}>
                                                            <td>{item.trsv_branch}</td>
                                                            <td>{item.trsv_remaining_qty}</td>
                                                            <td>{item.trsv_rate}</td>
                                                            <td>{item.trsv_valuation}</td>
                                                            {/* <td>{item.trsv_profit_loss}</td> */}
                                                            <th></th>
                                                        </tr>
                                                    </>
                                                ))
                                            }
                                        </tbody>

                                    </Table>
                                </Row>
                            </Row>
                        </> : null}
                    {scrMode === 'CNEVTM_ISD_CALCULATION' ?
                        <>
                            <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => handleBackScreenReportGeneration("CNEVTM_ISD_WISE")}>Back</Button>
                            <Row>
                                <h5>Stock Valuation ISD Calculation </h5>
                                {/* <Row>
                                    <Col className='col-md-3 col-6'>
                                        <Form.Label>Product : {headerProduct}</Form.Label>
                                    </Col>
                                    <Col className="col-md-2 col-4">
                                        <span>Valuation : <b>{headerValuation} </b></span>
                                    </Col>
                                    <Col className="col-md-2 col-4">
                                        <span>ISD : <b>{headerIsd} </b></span>
                                    </Col>
                                </Row> */}
                                <Row>
                                    <Table responsive bordered striped >
                                        <thead>
                                            <tr>
                                                <th>Branch</th>
                                                <th>Type </th>
                                                <th>Srno</th>
                                                <th>Line no </th>
                                                <th>Value</th>
                                                <th>Rate</th>
                                                <th>Total inr</th>
                                                <th>Tran Date</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                cnEvtmIsdCalculationData.map((item, index) => (
                                                    <>
                                                        <tr key={index}>
                                                            <td>{item.branch}</td>
                                                            <td>{item.tsvc_type}</td>
                                                            <td>{item.tsvc_prd_srno}</td>
                                                            <td>{item.tsvc_line_no}</td>
                                                            <td>{item.tsvc_calculated_value}</td>
                                                            <td>{item.tsvc_rate}</td>
                                                            <td>{item.tsvc_calculated_inr}</td>
                                                            <td>{item.tsvc_prd_date}</td>
                                                        </tr>
                                                    </>
                                                ))
                                            }
                                        </tbody>

                                    </Table>
                                </Row>
                            </Row>
                        </> : null}
                    {scrMode === 'CNEVTM_BRANCH_WISE' ?
                        <>
                            <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => handleBackScreenReportGeneration("CNEVTM_VIEW")}>Back</Button>
                            <Row>
                                <h5>Stock Valuation Branch Wise </h5>
                                <Row>
                                    <Col className='col-md-3 col-6'>
                                        <Form.Label>Product : {headerProduct}</Form.Label>
                                    </Col>
                                    <Col className="col-md-2 col-4">
                                        <span>Valuation : <b>{headerValuation} </b></span>
                                    </Col>
                                </Row>
                                <Row>
                                    <Table responsive bordered striped >
                                        <thead>
                                            <tr>
                                                <th>Branch</th>
                                                <th>Valuation</th>
                                                {/* <th>Profit & Loss</th> */}
                                                <th>&nbsp;</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                cnEvtmBranchWiseData.map((item, index) => (
                                                    <>
                                                        <tr key={index}>
                                                            <td>{item.trsv_branch}</td>
                                                            <td>{item.trsv_valuation}</td>
                                                            {/* <td>{item.trsv_profit_loss}</td> */}
                                                            <td>{
                                                                <span onClick={() => handleCnEvtmBranchToIsdWiseView(item.trsv_srno, item.trsv_product, item.trsv_branch_code, item.trsv_branch)} className='colorThemeBlue pointer'>ISD</span>
                                                            }</td>
                                                            <th></th>
                                                        </tr>
                                                    </>
                                                ))
                                            }
                                        </tbody>

                                    </Table>
                                </Row>
                            </Row>
                        </> : null}
                    {scrMode === 'CNEVTM_BRANCH_TO_ISD_WISE' ?
                        <>
                            <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => handleBackScreenReportGeneration("CNEVTM_BRANCH_WISE")}>Back</Button>
                            <Row>
                                <h5>Stock Valuation Branch To Isd Wise </h5>
                                <Row>
                                    <Col className="col-md-2 col-4">
                                        <span>Branch : <b>{headerBranch} </b></span>
                                    </Col>
                                    <Col className='col-md-3 col-6'>
                                        <Form.Label>Product : {headerProduct}</Form.Label>
                                    </Col>
                                    <Col className="col-md-2 col-4">
                                        <span>Valuation : <b>{headerValuation} </b></span>
                                    </Col>
                                </Row>
                                <Row>
                                    <Table responsive bordered striped >
                                        <thead>
                                            <tr>
                                                <th>ISD</th>
                                                <th>Quantity</th>
                                                <th>Rate</th>
                                                <th>Valuation</th>
                                                <th>&nbsp;</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                cnEvtmBranchToIsdWiseData.map((item, index) => (
                                                    <>
                                                        <tr key={index}>
                                                            <td>{item.trsv_isd}</td>
                                                            <td>{item.trsv_remaining_qty}</td>
                                                            <td>{item.trsv_rate}</td>
                                                            <td>{item.trsv_valuation}</td>
                                                            <th></th>
                                                        </tr>
                                                    </>
                                                ))
                                            }
                                        </tbody>

                                    </Table>
                                </Row>
                            </Row>
                        </> : null}
                    {scrMode === 'TRIAL_BALANCE_VIEW' ?
                        <>
                            <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => handleBackScreenReportGeneration("REPORT_GENERATION")}>Back</Button> &nbsp;
                            <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => handleViewDownload("TRIAL", 'V')}>Print</Button> &nbsp;
                            <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => handleViewDownload("TRIAL", 'D')}>Download</Button>
                            <Row>
                                <h5>Consolidate Trial</h5>
                                <Row>
                                    <Table responsive bordered striped >
                                        <thead>
                                            <tr>
                                                <th>Group</th>
                                                <th>Name</th>
                                                <th>Opening Debit</th>
                                                <th>Opening Credit</th>
                                                <th>Periodic Debit</th>
                                                <th>Periodic Credit</th>
                                                <th>Closing Debit</th>
                                                <th>Closing Credit</th>
                                                <th>&nbsp;</th>
                                                <th>&nbsp;</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                trialBalanceData.map((item, index) => (
                                                    <>
                                                        <tr key={index}>
                                                            <td>{item.trt_group}</td>
                                                            <td>{item.trt_group_name}</td>
                                                            <td>{item.trt_opn_debit}</td>
                                                            <td>{item.trt_opn_cr}</td>
                                                            <td>{item.trt_per_debit}</td>
                                                            <td>{item.trt_per_credit}</td>
                                                            <td>{item.trt_closing_debit}</td>
                                                            <td>{item.trt_closing_credit}</td>
                                                            <td>{
                                                                <span onClick={() => handleTrialAccountWiseView(item)} className='colorThemeBlue pointer'>Account</span>
                                                            }</td>
                                                            <td>{
                                                                <span onClick={() => handleTrialBranchWiseView(item)} className='colorThemeBlue pointer'>Branch</span>
                                                            }</td>
                                                        </tr>
                                                    </>
                                                ))
                                            }
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td colSpan="2"><strong>Total</strong></td>
                                                <td><strong>
                                                    {
                                                        (Math.round(trialBalanceData.reduce((total, item) => total + parseFloat(item.trt_opn_debit || 0), 0) * 100) / 100).toFixed(4)
                                                    }
                                                </strong></td>
                                                <td><strong>
                                                    {
                                                        (Math.round(trialBalanceData.reduce((total, item) => total + parseFloat(item.trt_opn_cr || 0), 0) * 100) / 100).toFixed(4)
                                                    }
                                                </strong></td>
                                                <td><strong>
                                                    {
                                                        (Math.round(trialBalanceData.reduce((total, item) => total + (parseFloat(item.trt_per_debit) || 0), 0) * 100) / 100).toFixed(4)
                                                    }
                                                </strong></td>

                                                <td><strong>
                                                    {
                                                        (Math.round(trialBalanceData.reduce((total, item) => total + (parseFloat(item.trt_per_credit) || 0), 0) * 100) / 100).toFixed(4)
                                                    }
                                                </strong></td>

                                                <td><strong>
                                                    {
                                                        (Math.round(trialBalanceData.reduce((total, item) => total + parseFloat(item.trt_closing_debit || 0), 0) * 100) / 100).toFixed(4)
                                                    }
                                                </strong></td>
                                                <td><strong>
                                                    {
                                                        (Math.round(trialBalanceData.reduce((total, item) => total + parseFloat(item.trt_closing_credit || 0), 0) * 100) / 100).toFixed(4)
                                                    }
                                                </strong></td>
                                                <td></td>
                                            </tr>
                                        </tfoot>

                                    </Table>
                                </Row>
                            </Row>
                        </> : null}
                    {scrMode === 'TRIAL_ACCOUNT_WISE' ?
                        <>
                            <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => handleBackScreenReportGeneration("TRIAL_BALANCE_VIEW")}>Back</Button>
                            <Row>
                                <h5>Consolidate Trial Account Wise</h5>
                                <Row>
                                    <Col className='col-md-3 col-6'>
                                        <Form.Label>Group : {headerGroup}</Form.Label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Table responsive bordered striped >
                                        <thead>
                                            <tr>
                                                <th>Account</th>
                                                <th>Name</th>
                                                <th>Opening Debit</th>
                                                <th>Opening Credit</th>
                                                <th>Periodic Debit</th>
                                                <th>Periodic Credit</th>
                                                <th>Closing Debit</th>
                                                <th>Closing Credit</th>
                                                <th>&nbsp;</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                trialAccountWiseData.map((item, index) => (
                                                    <>
                                                        <tr key={index}>
                                                            <td>{item.trt_account}</td>
                                                            <td>{item.trt_account_name}</td>
                                                            <td>{item.trt_opn_debit}</td>
                                                            <td>{item.trt_opn_cr}</td>
                                                            <td>{item.trt_per_debit}</td>
                                                            <td>{item.trt_per_credit}</td>
                                                            <td>{item.trt_closing_debit}</td>
                                                            <td>{item.trt_closing_credit}</td>
                                                            <td>{
                                                                <span onClick={() => handleTrialAccountToBranchWiseView(item)} className='colorThemeBlue pointer'>Branch</span>
                                                            }</td>
                                                        </tr>
                                                    </>
                                                ))
                                            }
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td colSpan="2"><strong>Total</strong></td>
                                                <td><strong>
                                                    {
                                                        (Math.round(trialAccountWiseData.reduce((total, item) => total + parseFloat(item.trt_opn_debit || 0), 0) * 100) / 100).toFixed(4)
                                                    }
                                                </strong></td>
                                                <td><strong>
                                                    {
                                                        (Math.round(trialAccountWiseData.reduce((total, item) => total + parseFloat(item.trt_opn_cr || 0), 0) * 100) / 100).toFixed(4)
                                                    }
                                                </strong></td>
                                                <td><strong>
                                                    {
                                                        (Math.round(trialAccountWiseData.reduce((total, item) => total + parseFloat(item.trt_per_debit || 0), 0) * 100) / 100).toFixed(4)
                                                    }
                                                </strong></td>
                                                <td><strong>
                                                    {
                                                        (Math.round(trialAccountWiseData.reduce((total, item) => total + parseFloat(item.trt_per_credit || 0), 0) * 100) / 100).toFixed(4)
                                                    }
                                                </strong></td>
                                                <td><strong>
                                                    {
                                                        (Math.round(trialAccountWiseData.reduce((total, item) => total + parseFloat(item.trt_closing_debit || 0), 0) * 100) / 100).toFixed(4)
                                                    }
                                                </strong></td>
                                                <td><strong>
                                                    {
                                                        (Math.round(trialAccountWiseData.reduce((total, item) => total + parseFloat(item.trt_closing_credit || 0), 0) * 100) / 100).toFixed(4)
                                                    }
                                                </strong></td>
                                                <td></td>
                                            </tr>
                                        </tfoot>

                                    </Table>
                                </Row>
                            </Row>
                        </> : null}
                    {scrMode === 'TRIAL_ACCOUNT_TO_BRANCH_WISE' ?
                        <>
                            <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => handleBackScreenReportGeneration("TRIAL_ACCOUNT_WISE")}>Back</Button>
                            <Row>
                                <h5>Consolidate Trial Account To Branch Wise</h5>
                                <Row>
                                    <Col className='col-md-3 col-6'>
                                        <Form.Label>Group : {headerGroup}</Form.Label>
                                    </Col>
                                    <Col className="col-md-2 col-4">
                                        <span>Account : <b>{headerAccount} </b></span>
                                    </Col>
                                </Row>
                                <Row>
                                    <Table responsive bordered striped >
                                        <thead>
                                            <tr>
                                                <th>Branch</th>
                                                <th>Opening Debit</th>
                                                <th>Opening Credit</th>
                                                <th>Periodic Debit</th>
                                                <th>Periodic Credit</th>
                                                <th>Closing Debit</th>
                                                <th>Closing Credit</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                trialAccountToBranchWiseData.map((item, index) => (
                                                    <>
                                                        <tr key={index}>
                                                            <td>{item.trt_branch}</td>
                                                            <td>{item.trt_opn_debit}</td>
                                                            <td>{item.trt_opn_cr}</td>
                                                            <td>{item.trt_per_debit}</td>
                                                            <td>{item.trt_per_credit}</td>
                                                            <td>{item.trt_closing_debit}</td>
                                                            <td>{item.trt_closing_credit}</td>
                                                        </tr>
                                                    </>
                                                ))
                                            }
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td colSpan="1"><strong>Total</strong></td>
                                                <td><strong>
                                                    {
                                                        (Math.round(trialAccountToBranchWiseData.reduce((total, item) => total + parseFloat(item.trt_opn_debit || 0), 0) * 100) / 100).toFixed(4)
                                                    }
                                                </strong></td>
                                                <td><strong>
                                                    {
                                                        (Math.round(trialAccountToBranchWiseData.reduce((total, item) => total + parseFloat(item.trt_opn_cr || 0), 0) * 100) / 100).toFixed(4)
                                                    }
                                                </strong></td>
                                                <td><strong>
                                                    {
                                                        (Math.round(trialAccountToBranchWiseData.reduce((total, item) => total + parseFloat(item.trt_per_debit || 0), 0) * 100) / 100).toFixed(4)
                                                    }
                                                </strong></td>
                                                <td><strong>
                                                    {
                                                        (Math.round(trialAccountToBranchWiseData.reduce((total, item) => total + parseFloat(item.trt_per_credit || 0), 0) * 100) / 100).toFixed(4)
                                                    }
                                                </strong></td>
                                                <td><strong>
                                                    {
                                                        (Math.round(trialAccountToBranchWiseData.reduce((total, item) => total + parseFloat(item.trt_closing_debit || 0), 0) * 100) / 100).toFixed(4)
                                                    }
                                                </strong></td>
                                                <td><strong>
                                                    {
                                                        (Math.round(trialAccountToBranchWiseData.reduce((total, item) => total + parseFloat(item.trt_closing_credit || 0), 0) * 100) / 100).toFixed(4)
                                                    }
                                                </strong></td>
                                                <td></td>
                                            </tr>
                                        </tfoot>

                                    </Table>
                                </Row>
                            </Row>
                        </> : null}
                    {scrMode === 'TRIAL_BRANCH_WISE' ?
                        <>
                            <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => handleBackScreenReportGeneration("TRIAL_BALANCE_VIEW")}>Back</Button>
                            <Row>
                                <h5>Consolidate Trial Branch Wise</h5>
                                <Row>
                                    <Col className='col-md-3 col-6'>
                                        <Form.Label>Group : {headerGroup}</Form.Label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Table responsive bordered striped >
                                        <thead>
                                            <tr>
                                                <th>Branch</th>
                                                <th>Opening Debit</th>
                                                <th>Opening Credit</th>
                                                <th>Periodic Debit</th>
                                                <th>Periodic Credit</th>
                                                <th>Closing Debit</th>
                                                <th>Closing Credit</th>
                                                <th>&nbsp;</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                trialBranchWiseData.map((item, index) => (
                                                    <>
                                                        <tr key={index}>
                                                            <td>{item.trt_branch}</td>
                                                            <td>{item.trt_opn_debit}</td>
                                                            <td>{item.trt_opn_cr}</td>
                                                            <td>{item.trt_per_debit}</td>
                                                            <td>{item.trt_per_credit}</td>
                                                            <td>{item.trt_closing_debit}</td>
                                                            <td>{item.trt_closing_credit}</td>
                                                            <td>{
                                                                <span onClick={() => handleTrialBranchToAccountWiseView(item)} className='colorThemeBlue pointer'>Account</span>
                                                            }</td>
                                                        </tr>
                                                    </>
                                                ))
                                            }
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td colSpan="1"><strong>Total</strong></td>
                                                <td><strong>
                                                    {
                                                        (Math.round(trialBranchWiseData.reduce((total, item) => total + parseFloat(item.trt_opn_debit || 0), 0) * 100) / 100).toFixed(4)
                                                    }
                                                </strong></td>
                                                <td><strong>
                                                    {
                                                        (Math.round(trialBranchWiseData.reduce((total, item) => total + parseFloat(item.trt_opn_cr || 0), 0) * 100) / 100).toFixed(4)
                                                    }
                                                </strong></td>
                                                <td><strong>
                                                    {
                                                        (Math.round(trialBranchWiseData.reduce((total, item) => total + parseFloat(item.trt_per_debit || 0), 0) * 100) / 100).toFixed(4)
                                                    }
                                                </strong></td>
                                                <td><strong>
                                                    {
                                                        (Math.round(trialBranchWiseData.reduce((total, item) => total + parseFloat(item.trt_per_credit || 0), 0) * 100) / 100).toFixed(4)
                                                    }
                                                </strong></td>
                                                <td><strong>
                                                    {
                                                        (Math.round(trialBranchWiseData.reduce((total, item) => total + parseFloat(item.trt_closing_debit || 0), 0) * 100) / 100).toFixed(4)
                                                    }
                                                </strong></td>
                                                <td><strong>
                                                    {
                                                        (Math.round(trialBranchWiseData.reduce((total, item) => total + parseFloat(item.trt_closing_credit || 0), 0) * 100) / 100).toFixed(4)
                                                    }
                                                </strong></td>
                                                <td></td>
                                            </tr>
                                        </tfoot>

                                    </Table>
                                </Row>
                            </Row>
                        </> : null}
                    {scrMode === 'TRIAL_BRANCH_TO_ACCOUNT_WISE' ?
                        <>
                            <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => handleBackScreenReportGeneration("TRIAL_BRANCH_WISE")}>Back</Button>
                            <Row>
                                <h5>Consolidate Trial Branch To Account Wise</h5>
                                <Row>
                                    <Col className='col-md-3 col-6'>
                                        <Form.Label>Group : {headerGroup}</Form.Label>
                                    </Col>
                                    <Col className="col-md-2 col-4">
                                        <span>Account : <b>{headerAccount} </b></span>
                                    </Col>
                                </Row>
                                <Row>
                                    <Table responsive bordered striped >
                                        <thead>
                                            <tr>
                                                <th>Account</th>
                                                <th> Name </th>
                                                <th>Opening Debit</th>
                                                <th>Opening Credit</th>
                                                <th>Periodic Debit</th>
                                                <th>Periodic Credit</th>
                                                <th>Closing Debit</th>
                                                <th>Closing Credit</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                trialBrancToAccounthWiseData.map((item, index) => (
                                                    <>
                                                        <tr key={index}>
                                                            <td>{item.trt_account}</td>
                                                            <td>{item.trt_account_name}</td>
                                                            <td>{item.trt_opn_debit}</td>
                                                            <td>{item.trt_opn_cr}</td>
                                                            <td>{item.trt_per_debit}</td>
                                                            <td>{item.trt_per_credit}</td>
                                                            <td>{item.trt_closing_debit}</td>
                                                            <td>{item.trt_closing_credit}</td>
                                                        </tr>
                                                    </>
                                                ))
                                            }
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td colSpan="2"><strong>Total</strong></td>
                                                <td><strong>
                                                    {
                                                        (Math.round(trialBrancToAccounthWiseData.reduce((total, item) => total + parseFloat(item.trt_opn_debit || 0), 0) * 100) / 100).toFixed(4)
                                                    }
                                                </strong></td>
                                                <td><strong>
                                                    {
                                                        (Math.round(trialBrancToAccounthWiseData.reduce((total, item) => total + parseFloat(item.trt_opn_cr || 0), 0) * 100) / 100).toFixed(4)
                                                    }
                                                </strong></td>
                                                <td><strong>
                                                    {
                                                        (Math.round(trialBrancToAccounthWiseData.reduce((total, item) => total + parseFloat(item.trt_per_debit || 0), 0) * 100) / 100).toFixed(4)
                                                    }
                                                </strong></td>
                                                <td><strong>
                                                    {
                                                        (Math.round(trialBrancToAccounthWiseData.reduce((total, item) => total + parseFloat(item.trt_per_credit || 0), 0) * 100) / 100).toFixed(4)
                                                    }
                                                </strong></td>
                                                <td><strong>
                                                    {
                                                        (Math.round(trialBrancToAccounthWiseData.reduce((total, item) => total + parseFloat(item.trt_closing_debit || 0), 0) * 100) / 100).toFixed(4)
                                                    }
                                                </strong></td>
                                                <td><strong>
                                                    {
                                                        (Math.round(trialBrancToAccounthWiseData.reduce((total, item) => total + parseFloat(item.trt_closing_credit || 0), 0) * 100) / 100).toFixed(4)
                                                    }
                                                </strong></td>
                                                <td></td>
                                            </tr>
                                        </tfoot>

                                    </Table>
                                </Row>
                            </Row>
                        </> : null}
                    {scrMode === 'TRADING_BALANCE_VIEW' ?
                        <>
                            <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => handleBackScreenReportGeneration("REPORT_GENERATION")}>Back</Button>
                            <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => handleViewDownload("TRADING", 'V')}>Print</Button> &nbsp;
                            <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => handleViewDownload("TRADING", 'D')}>Download</Button>
                            <Row>
                                <h5>Trading Wise Balance Sheet</h5>
                                <Row>
                                    <Table responsive bordered striped >
                                        <thead>
                                            <tr>
                                                <th>Group</th>
                                                <th>Account</th>
                                                <th>Account Name </th>
                                                <th>Closing Debit</th>
                                                <th>Closing Credit</th>
                                                <th>Branch</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                tradingBalanceData.map((item, index) => (
                                                    <>
                                                        <tr key={index}>
                                                            <td>{item.trt_group}</td>
                                                            <td>{item.trt_account}</td>
                                                            <td>{item.trt_account_name}</td>
                                                            <td>{item.trt_closing_debit}</td>
                                                            <td>{item.trt_closing_credit}</td>
                                                            <td>{
                                                                <span onClick={() => handleTradingToBranchWiseView(item)} className='colorThemeBlue pointer'>Branch</span>
                                                            }</td>
                                                        </tr>
                                                    </>
                                                ))
                                            }
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td colSpan="3"><strong>Total</strong></td>
                                                <td><strong>
                                                    {
                                                        (Math.round(tradingBalanceData.reduce((total, item) => total + parseFloat(item.trt_closing_debit || 0), 0) * 100) / 100).toFixed(4)
                                                    }
                                                </strong></td>
                                                <td><strong>
                                                    {
                                                        (Math.round(tradingBalanceData.reduce((total, item) => total + parseFloat(item.trt_closing_credit || 0), 0) * 100) / 100).toFixed(4)
                                                    }
                                                </strong></td>
                                                <td></td>
                                            </tr>
                                        </tfoot>

                                    </Table>
                                </Row>
                            </Row>
                        </> : null}
                    {scrMode === 'TRADING_BRANCH_WISE' ?
                        <>
                            <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => handleBackScreenReportGeneration("TRADING_BALANCE_VIEW")}>Back</Button>
                            <Row>
                                <h5>Trading Branch Wise Balance Sheet</h5>
                                <Row>
                                    <Col className='col-md-3 col-6'>
                                        <Form.Label>Group : {headerGroup}</Form.Label>
                                    </Col>
                                    <Col className="col-md-2 col-4">
                                        <span>Account : <b>{headerAccount} </b></span>
                                    </Col>
                                </Row>
                                <Row>
                                    <Table responsive bordered striped >
                                        <thead>
                                            <tr>
                                                <th>Branch</th>
                                                <th>Closing Debit</th>
                                                <th>Closing Credit</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                tradingToBranchWiseData.map((item, index) => (
                                                    <>
                                                        <tr key={index}>
                                                            <td>{item.trt_branch}</td>
                                                            <td>{item.trt_closing_debit}</td>
                                                            <td>{item.trt_closing_credit}</td>
                                                        </tr>
                                                    </>
                                                ))
                                            }
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td colSpan="1"><strong>Total</strong></td>
                                                <td><strong>
                                                    {
                                                        (Math.round(tradingToBranchWiseData.reduce((total, item) => total + parseFloat(item.trt_closing_debit || 0), 0) * 100) / 100).toFixed(4)
                                                    }
                                                </strong></td>
                                                <td><strong>
                                                    {
                                                        (Math.round(tradingToBranchWiseData.reduce((total, item) => total + parseFloat(item.trt_closing_credit || 0), 0) * 100) / 100).toFixed(4)
                                                    }
                                                </strong></td>
                                                <td></td>
                                            </tr>
                                        </tfoot>

                                    </Table>
                                </Row>
                            </Row>
                        </> : null}
                    {scrMode === 'SCHEDULE_PARENT_GROUP_WISE' ?
                        <>
                            <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => handleBackScreenReportGeneration("REPORT_GENERATION")}>Back</Button>

                            <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => handleViewDownload("SLWBS", 'D')}>Download</Button>
                            <Row>
                                <h5>Schedule Level Wise Balance Sheet</h5>
                                <Row>
                                    <Table responsive bordered striped >
                                        <thead>
                                            <tr>
                                                <th>Group Name</th>
                                                <th>Debit </th>
                                                <th>Credit</th>
                                                <th>&nbsp;</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                scheduleParentGroupWiseData.map((item, index) => (
                                                    <>
                                                        <tr key={index}>
                                                            <td>{item.mbs_name}</td>
                                                            <td>{item.trt_closing_debit}</td>
                                                            <td>{item.trt_closing_credit}</td>
                                                            <td>{
                                                                <span onClick={() => handleScheduleChildGroupWiseView(item)} className='colorThemeBlue pointer'>Group</span>
                                                            }</td>
                                                        </tr>
                                                    </>
                                                ))
                                            }
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td colSpan="1"><strong>Total</strong></td>
                                                <td><strong>
                                                    {
                                                        (Math.round(scheduleParentGroupWiseData.reduce((total, item) => total + parseFloat(item.trt_closing_debit || 0), 0) * 100) / 100).toFixed(4)
                                                    }
                                                </strong></td>
                                                <td><strong>
                                                    {
                                                        (Math.round(scheduleParentGroupWiseData.reduce((total, item) => total + parseFloat(item.trt_closing_credit || 0), 0) * 100) / 100).toFixed(4)
                                                    }
                                                </strong></td>
                                                <td></td>
                                            </tr>
                                        </tfoot>

                                    </Table>
                                </Row>
                            </Row>
                        </> : null}
                    {scrMode === 'SCHEDULE_CHILD_GROUP_WISE' ?
                        <>
                            <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => handleBackScreenReportGeneration("SCHEDULE_PARENT_GROUP_WISE")}>Back</Button>
                            <Row>
                                <h5>Schedule Balance Sheet</h5>
                                <Row>
                                    <Table responsive bordered striped >
                                        <thead>
                                            <tr>
                                                <th>Group</th>
                                                <th>Group Name</th>
                                                <th>Debit </th>
                                                <th>Credit</th>
                                                <th>&nbsp;</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                scheduleChildGroupWiseData.map((item, index) => (
                                                    <>
                                                        <tr key={index}>
                                                            <td>{item.trt_group}</td>
                                                            <td>{item.trt_group_name}</td>
                                                            <td>{item.trt_closing_debit}</td>
                                                            <td>{item.trt_closing_credit}</td>
                                                            <td>{
                                                                <span onClick={() => handleScheduleChildGroupToBranchWiseView(item)} className='colorThemeBlue pointer'>Branch</span>
                                                            }</td>
                                                        </tr>
                                                    </>
                                                ))
                                            }
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td colSpan="2"><strong>Total</strong></td>
                                                <td><strong>
                                                    {
                                                        (Math.round(scheduleChildGroupWiseData.reduce((total, item) => total + parseFloat(item.trt_closing_debit || 0), 0) * 100) / 100).toFixed(4)
                                                    }
                                                </strong></td>
                                                <td><strong>
                                                    {
                                                        (Math.round(scheduleChildGroupWiseData.reduce((total, item) => total + parseFloat(item.trt_closing_credit || 0), 0) * 100) / 100).toFixed(4)
                                                    }
                                                </strong></td>
                                                <td></td>
                                            </tr>
                                        </tfoot>

                                    </Table>
                                </Row>
                            </Row>
                        </> : null}
                    {scrMode === 'SCHEDULE_CHILD_GROUP_TO_BRANCH_WISE' ?
                        <>
                            <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => handleBackScreenReportGeneration("SCHEDULE_CHILD_GROUP_WISE")}>Back</Button>
                            <Row>
                                <h5>Schedule Balance Sheet Branch Wise</h5>
                                <Row>
                                    <Col className='col-md-3 col-6'>
                                        <Form.Label>Group : {headerGroup}</Form.Label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Table responsive bordered striped >
                                        <thead>
                                            <tr>
                                                <th>Branch</th>
                                                <th>Debit </th>
                                                <th>Credit</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                scheduleChildGroupToBranchWiseData.map((item, index) => (
                                                    <>
                                                        <tr key={index}>
                                                            <td>{item.trt_branch}</td>
                                                            <td>{item.trt_closing_debit}</td>
                                                            <td>{item.trt_closing_credit}</td>
                                                        </tr>
                                                    </>
                                                ))
                                            }
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td colSpan="2"><strong>Total</strong></td>
                                                <td><strong>
                                                    {
                                                        (Math.round(scheduleChildGroupToBranchWiseData.reduce((total, item) => total + parseFloat(item.trt_closing_debit || 0), 0) * 100) / 100).toFixed(4)
                                                    }
                                                </strong></td>
                                                <td><strong>
                                                    {
                                                        (Math.round(scheduleChildGroupToBranchWiseData.reduce((total, item) => total + parseFloat(item.trt_closing_credit || 0), 0) * 100) / 100).toFixed(4)
                                                    }
                                                </strong></td>
                                                <td></td>
                                            </tr>
                                        </tfoot>

                                    </Table>
                                </Row>
                            </Row>
                        </> : null}
                    {scrMode === 'PROFITLOSS_GROUP_WISE' ?
                        <>
                            <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => handleBackScreenReportGeneration("REPORT_GENERATION")}>Back</Button>
                            <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => handleViewDownload("PROFITLOSS", 'V')}>Print</Button> &nbsp;
                            <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => handleViewDownload("PROFITLOSS", 'D')}>Download</Button>
                            <Row>
                                <h5>Profit and Loss Balance Sheet</h5>


                                <Row>
                                    <Table responsive bordered striped >
                                        <thead>
                                            <tr>
                                                <th>Group</th>
                                                <th>Group Name</th>
                                                <th>Debit </th>
                                                <th>Credit</th>
                                                <th>&nbsp;</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                profitLossGroupWiseData.map((item, index) => (
                                                    <>
                                                        <tr key={index}>
                                                            <td>{item.trt_group}</td>
                                                            <td>{item.trt_group_name}</td>
                                                            <td>{item.trt_closing_debit}</td>
                                                            <td>{item.trt_closing_credit}</td>
                                                            <td>{
                                                                <span onClick={() => handleProfitLossGroupToAccountWiseView(item)} className='colorThemeBlue pointer'>Account</span>
                                                            }</td>
                                                        </tr>
                                                    </>
                                                ))
                                            }
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td colSpan="2"><strong>Total</strong></td>
                                                <td><strong>
                                                    {
                                                        (Math.round(profitLossGroupWiseData.reduce((total, item) => total + parseFloat(item.trt_closing_debit || 0), 0) * 100) / 100).toFixed(4)
                                                    }
                                                </strong></td>
                                                <td><strong>
                                                    {
                                                        (Math.round(profitLossGroupWiseData.reduce((total, item) => total + parseFloat(item.trt_closing_credit || 0), 0) * 100) / 100).toFixed(4)
                                                    }
                                                </strong></td>
                                                <td></td>
                                            </tr>
                                        </tfoot>
                                    </Table>

                                </Row>
                            </Row>
                        </> : null}
                    {scrMode === 'PROFITLOSS_GROUP_TO_ACCOUNT_WISE' ?
                        <>
                            <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => handleBackScreenReportGeneration("PROFITLOSS_GROUP_WISE")}>Back</Button>
                            <h5>Profit and Loss Group To Account Wise Balance Sheet</h5>
                            <Row>
                                <Col className='col-md-3 col-6'>
                                    <Form.Label>Group : {headerGroup}</Form.Label>
                                </Col>
                            </Row>
                            <Row>
                                <Table responsive bordered striped >
                                    <thead>
                                        <tr>
                                            <th>Account</th>
                                            <th>Account Name</th>
                                            <th>Debit </th>
                                            <th>Credit</th>
                                            <th>&nbsp;</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            plGrpToAccountWiseData.map((item, index) => (
                                                <>
                                                    <tr key={index}>
                                                        <td>{item.trt_account}</td>
                                                        <td>{item.trt_account_name}</td>
                                                        <td>{item.trt_closing_debit}</td>
                                                        <td>{item.trt_closing_credit}</td>
                                                        <td>{
                                                            <span onClick={() => handlePLGroupAccountToBranchWiseView(item)} className='colorThemeBlue pointer'>Branch</span>
                                                        }</td>
                                                    </tr>
                                                </>
                                            ))
                                        }
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td colSpan="2"><strong>Total</strong></td>
                                            <td><strong>
                                                {
                                                    (Math.round(plGrpToAccountWiseData.reduce((total, item) => total + parseFloat(item.trt_closing_debit || 0), 0) * 100) / 100).toFixed(4)
                                                }
                                            </strong></td>
                                            <td><strong>
                                                {
                                                    (Math.round(plGrpToAccountWiseData.reduce((total, item) => total + parseFloat(item.trt_closing_credit || 0), 0) * 100) / 100).toFixed(4)
                                                }
                                            </strong></td>
                                            <td></td>
                                        </tr>
                                    </tfoot>

                                </Table>
                            </Row>
                        </> : null}
                    {scrMode === 'PROFITLOSS_GROUPACCOUNT_TO_BRANCH_WISE' ?
                        <>
                            <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => handleBackScreenReportGeneration("PROFITLOSS_GROUP_WISE")}>Back</Button>
                            <h5>Profit and Loss Group To Account to Brance Wise Balance Sheet</h5>
                            <Row>
                                <Col className='col-md-3 col-6'>
                                    <Form.Label>Group : {headerGroup}</Form.Label>
                                </Col>
                                <Col className="col-md-2 col-4">
                                    <span>Account : <b>{headerAccount} </b></span>
                                </Col>
                            </Row>
                            <Row>
                                <Table responsive bordered striped >
                                    <thead>
                                        <tr>
                                            <th>Branch</th>
                                            <th>Debit </th>
                                            <th>Credit</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            pLGroupAccountToBranchWiseData.map((item, index) => (
                                                <>
                                                    <tr key={index}>
                                                        <td>{item.trt_branch}</td>
                                                        <td>{item.trt_closing_debit}</td>
                                                        <td>{item.trt_closing_credit}</td>
                                                    </tr>
                                                </>
                                            ))
                                        }
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td colSpan="1"><strong>Total</strong></td>
                                            <td><strong>
                                                {
                                                    (Math.round(pLGroupAccountToBranchWiseData.reduce((total, item) => total + parseFloat(item.trt_closing_debit || 0), 0) * 100) / 100).toFixed(4)
                                                }
                                            </strong></td>
                                            <td><strong>
                                                {
                                                    (Math.round(pLGroupAccountToBranchWiseData.reduce((total, item) => total + parseFloat(item.trt_closing_credit || 0), 0) * 100) / 100).toFixed(4)
                                                }
                                            </strong></td>
                                            <td></td>
                                        </tr>
                                    </tfoot>

                                </Table>
                            </Row>
                        </> : null}
                </>
            </Container>

            <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                {msgText}
            </Dialog>


            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
        </div>
    )
}

export default Balance_sheet
